var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPharmacy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5C35 18.1169 34.9679 18.7267 34.9053 19.327C34.8959 19.4189 34.8859 19.5108 34.8748 19.6022C33.919 27.5869 27.5869 33.919 19.6022 34.8748C19.5108 34.8859 19.4189 34.8959 19.327 34.9053C18.7267 34.9679 18.1169 35 17.5 35C7.83513 35 0 27.1649 0 17.5C0 7.83513 7.83513 0 17.5 0C27.1649 0 35 7.83513 35 17.5Z",
    fill: "#E96666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.327 34.9053L6.05688 21.6352L21.6352 6.05687L34.9053 19.327C34.8959 19.4189 34.8859 19.5108 34.8748 19.6022C33.919 27.5869 27.5869 33.919 19.6022 34.8748C19.5108 34.8859 19.4189 34.8959 19.327 34.9053Z",
    fill: "#B53D3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6354 28.9431H13.3647V6.05688H21.6354V28.9431Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05688 21.6353V13.3646H28.9431V21.6353H6.05688Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacy);
export default __webpack_public_path__ + "static/media/pharmacy.cd818bb5f5db6cceb3f783968aa447c2.svg";
export { ForwardRef as ReactComponent };